import React, { useEffect } from 'react';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';
import { resolveLoadingColorsByVariant, LoadingColors } from '../../utilities/loadingColors';
import { useEnvironmentVariables } from '../../ui-toolkit/environmentVariables/useEnvironmentVariables';

const LoadingColorsApplier: React.FC = () => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const { data } = useEnvironmentVariables();

  useEffect(() => {
    const colors: LoadingColors = resolveLoadingColorsByVariant(data?.pineconeAnimationColor);
    document.documentElement.style.setProperty('--theme-dark-color', colors.darkColor);
    document.documentElement.style.setProperty('--theme-light-color', colors.lightColor);
  }, [data, isZillowClosingEnabled]);

  return null;
};

export default LoadingColorsApplier;
